import { BreakdownMessageTypeLoading } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/messageType/BreakdownMessageTypeLoading';
import { FlexSpacer } from 'ui/flexSpacer';
import { Skeleton } from 'ui/skeleton';

export const BreakdownTabsContentLoading = () => {
  return (
    <>
      <Skeleton height={50} width={1160} />
      <FlexSpacer flexDirection="row" gap="base">
        <Skeleton height={190} width={378} />
        <Skeleton height={190} width={378} />
        <Skeleton height={190} width={378} />
      </FlexSpacer>
      <BreakdownMessageTypeLoading />
    </>
  );
};
